/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Guard_TitleInputs */

const en_mk_loop_guard_title = /** @type {(inputs: Mk_Loop_Guard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guard hook for Claude Code`)
};

const id_mk_loop_guard_title = /** @type {(inputs: Mk_Loop_Guard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hook guard untuk Claude Code`)
};

/**
* | output |
* | --- |
* | "Guard hook for Claude Code" |
*
* @param {Mk_Loop_Guard_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_guard_title = /** @type {((inputs?: Mk_Loop_Guard_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Guard_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_guard_title(inputs)
	return en_mk_loop_guard_title(inputs)
});